import { render, staticRenderFns } from "./FIFAWorldCupFull_WCQAZ.vue?vue&type=template&id=18796e20"
import script from "./FIFAWorldCupFull_WCQAZ.vue?vue&type=script&lang=js"
export * from "./FIFAWorldCupFull_WCQAZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports